import { Locale } from '@ps-smart-cp/ppfw-client';

const userMaintenanceOrderItemNameConfig = {
  userId: new Map([
    [Locale.ja, 'ユーザID'],
    [Locale.en, 'User Id'],
  ]),

  mstSpareNameOne: new Map([
    [Locale.ja, '予備名称1'],
    [Locale.en, 'Master Spare Name One'],
  ]),

  mstSpareNameTwo: new Map([
    [Locale.ja, '予備名称2'],
    [Locale.en, 'Master Spare Name Two'],
  ]),
} satisfies Record<string, Map<Locale, string>>;

export { userMaintenanceOrderItemNameConfig };
